export default __webpack_public_path__ + "static/media/no-keyword.f4c479b4.png";